/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CancelInputs */

const th_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const en_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const ja_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const zh_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const es_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const pt_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const id_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const fr_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const tl_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanselahin`)
};

const vi_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ`)
};

const ko_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소`)
};

const de_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const ru_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const tr_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vazgeç`)
};

const it_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const pl_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj`)
};

const uk_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати`)
};

const hi_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करें`)
};

const ar_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء`)
};

const ms_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const bn_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাতিল`)
};

const zh_tw2_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const zh_hk2_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ur_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منسوخ`)
};

const fa_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انصراف`)
};

const sw_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghairi`)
};

const nl_cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {CancelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const cancel = /** @type {((inputs?: CancelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CancelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_cancel(inputs)
	if (locale === "ja") return ja_cancel(inputs)
	if (locale === "zh") return zh_cancel(inputs)
	if (locale === "es") return es_cancel(inputs)
	if (locale === "pt") return pt_cancel(inputs)
	if (locale === "id") return id_cancel(inputs)
	if (locale === "fr") return fr_cancel(inputs)
	if (locale === "tl") return tl_cancel(inputs)
	if (locale === "vi") return vi_cancel(inputs)
	if (locale === "ko") return ko_cancel(inputs)
	if (locale === "de") return de_cancel(inputs)
	if (locale === "ru") return ru_cancel(inputs)
	if (locale === "tr") return tr_cancel(inputs)
	if (locale === "it") return it_cancel(inputs)
	if (locale === "pl") return pl_cancel(inputs)
	if (locale === "uk") return uk_cancel(inputs)
	if (locale === "hi") return hi_cancel(inputs)
	if (locale === "ar") return ar_cancel(inputs)
	if (locale === "ms") return ms_cancel(inputs)
	if (locale === "bn") return bn_cancel(inputs)
	if (locale === "zh-TW") return zh_tw2_cancel(inputs)
	if (locale === "zh-HK") return zh_hk2_cancel(inputs)
	if (locale === "ur") return ur_cancel(inputs)
	if (locale === "fa") return fa_cancel(inputs)
	if (locale === "sw") return sw_cancel(inputs)
	if (locale === "nl") return nl_cancel(inputs)
	return en_cancel(inputs)
});